module.exports = __webpack_public_path__ + "img/bend_over.198df57b.png";